import { useAppSelector } from 'shared/hooks/redux/hooks';
import { createSelector } from '@reduxjs/toolkit';
import { createSubsetSelector, selectStripItemsOfArray } from 'webui/utils/selectors';
import { selectDevice, selectDevices } from 'entities/device/lib';
import { getFirmwareVersionHuman, hasFirmwareUpdate, isFirmwareDeclined, } from 'entities/device.service.upgrades/lib/firmware';
import { firmware_keys, } from 'entities/device.service.upgrades/model/types';
import { removeNulls } from 'utils';
import { getDeviceFirmwareHumanVersion } from 'console/device/device_ts';
import { LegacyDevice } from 'console/device/device';
const getFirmwareDevice = createSelector((state, device_id) => selectDevice(state, device_id), 
// @ts-ignore need readonly
createSubsetSelector(firmware_keys));
export const getFirmwareDevices = createSelector(selectDevices, 
// @ts-ignore need readonly
selectStripItemsOfArray(firmware_keys));
export function useHasFirmwareUpdate(device_id) {
    const device = useAppSelector((state) => getFirmwareDevice(state, device_id));
    const last_firmwares = useAppSelector((state) => state.last_firmwares);
    const user_id = useAppSelector((state) => state.account.id);
    const { available } = hasFirmwareUpdate(user_id, last_firmwares, device, true);
    return available;
}
export function useGetDeviceUpdateSuggestions() {
    const devices = useAppSelector(getFirmwareDevices);
    const last_firmwares = useAppSelector((state) => state.last_firmwares);
    const user_id = useAppSelector((state) => state.account.id);
    return removeNulls(devices.map((dev) => {
        const { available, firmware } = hasFirmwareUpdate(user_id, last_firmwares, dev, true);
        if (!available) {
            return null;
        }
        if (firmware == null) {
            return null;
        }
        if (isFirmwareDeclined(dev, firmware)) {
            return null;
        }
        return {
            device: {
                device_id: dev.id,
                name: LegacyDevice.display_name(dev),
            },
            version: {
                current: getDeviceFirmwareHumanVersion(dev),
                last: getFirmwareVersionHuman(firmware),
                original: firmware.version,
            },
        };
    }));
}
